import React, { PureComponent } from "react";
import { connect } from "react-redux";
import "./LoginPage.css";
import InputGroup from 'react-bootstrap/InputGroup';
import Card from 'react-bootstrap/Card';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { forwardTo } from '../../helpers'
import {
  loginRequest,
  clearError,
  userLogout,
  entityActions,
  socialLogin,
  socialLogout,
  resetPasswordRequest
} from "../../actions";
import { defaultAyuntamientoID, googleClientId, facebookAppId } from '../../constants';
// import { forwardTo } from './../../helpers';
import queryString from "query-string";
import {
  DynamicBackground,
  EntitySearch,
  SocialLogin,
  BannerCertificate
} from "./../../components";

import { history } from "./../../helpers";
import { withTranslation } from "react-i18next";
import { isWebpSupported } from "react-image-webp/dist/utils";

class LoginPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      submitted: false,
      open: false,
      ao: queryString.parse(this.props.location.search),
      loginRequired: this.props.location.state ? this.props.location.state.loginRequired : false,
      hideChangeEntity: defaultAyuntamientoID == 1 ? true : false,
      entityName: 'Gecor',
      errorReset: "",
    };
    this.props.prepareUser();
    this.props.clearError();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeEntity = this.handleChangeEntity.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseLoginRequiredModal = this.handleCloseLoginRequiredModal.bind(this);
    this.handleSelectedEntity = this.handleSelectedEntity.bind(this);

    const { ao } = this.state;
    if (ao && ao.ao && ao.ao !== "0") {
      this.props.getEntityById({ id: ao.ao, redirect: false });
    } else if (defaultAyuntamientoID == 1) {
      this.props.getEntityById({ id: defaultAyuntamientoID, redirect: false });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.prepareGoogle();
    this.props.prepareFacebook();
    if (!this.state.ao || !this.state.ao.ao) this.props.loadLocalEntity();
  }

  componentDidUpdate(prevProps) {
    // Sincronizar estado 'ao' si la URL cambia (p.e. al pulsar el logo en la cabecera)
    if (this.props.location.search !== prevProps.location.search) {
      this.setState({ ao: queryString.parse(this.props.location.search) });
    }
  }

  handleChange(e) {
    const { error } = this.props;
    if (error) this.props.clearError();

    const { name, value } = e.target;
    this.setState({ [name]: value, errorReset: "" });
  }

  normalizeInternalUrl(pathAndQuery) {
    // pathAndQuery puede venir contaminado con "??" o "?a?b"
    const [path, ...rest] = String(pathAndQuery).split('?');
    if (!rest.length) return path;

    // convierte interrogantes extra en &
    const queryRaw = rest.join('&');

    const params = new URLSearchParams(queryRaw);

    // elimina cualquier returnUrl que se haya colado dentro del destino
    params.delete('returnUrl');

    // dedup de ao (set deja solo uno)
    if (params.has('ao')) {
      const ao = params.get('ao');
      params.delete('ao');
      params.set('ao', ao);
    }

    const qs = params.toString();
    return qs ? `${path}?${qs}` : path;
  }

  getSafeReturnUrl() {
    const qs = queryString.parse(this.props.location.search);
    let raw = qs?.returnUrl ? String(qs.returnUrl) : null;
    if (!raw) return null;

    try { raw = decodeURIComponent(raw); } catch { }

    // si viene anidado /login?returnUrl=...
    if (raw.startsWith('/login')) {
      const idx = raw.indexOf('?');
      if (idx >= 0) {
        const inner = new URLSearchParams(raw.substring(idx + 1).replace(/\?/g, '&'));
        raw = inner.get('returnUrl');
        if (!raw) return null;
        try { raw = decodeURIComponent(raw); } catch { }
      } else {
        return null;
      }
    }

    if (!raw.startsWith('/') || raw.startsWith('/login')) return null;

    return this.normalizeInternalUrl(raw);
  }

  getReturnUrlFromQuery() {
    const qs = queryString.parse(this.props.location.search);
    const raw = qs?.returnUrl ? String(qs.returnUrl) : null;
    return this.extractReturnUrl(raw);
  }


  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { entity } = this.props;

    if (entity && entity.AyuntamientoID === 0) {
      this.handleChangeEntity(e);
      return;
    }

    if (email && password && entity) {
      const returnUrl = this.getSafeReturnUrl();
      this.props.login({ email, password, entity, returnUrl });
    }
  }

  handleResetPassword(e) {
    e.preventDefault();
    const { emailModal: email } = this.state;
    const { resetPassword } = this.props;

    if (email) {
      this.props.resetPassword({ email });
      if (resetPassword) {
        // this.setState({ open: false, emailModal: "", errorReset: "" });
        this.setState({ successReset: "login.resetSucess" });
      } else {
        this.setState({ errorReset: "login.emailNotValid" });
      }
    }
  }

  handleClose() {
    this.setState({ open: false, errorReset: "", successReset: "" });
  }

  handleCloseLoginRequiredModal() {
    this.setState({ loginRequired: false });
    history.replace({ pathname: '/login', state: {} })
  }

  handleShow(e) {
    e.preventDefault();
    this.setState({ open: true });
  }

  handleChangeEntity(e) {
    if (e) e.preventDefault();
    localStorage.removeItem("Server");
    this.setState({ ao: { ao: 0 } });
    if (defaultAyuntamientoID != 1 && !this.state.hideChangeEntity) {
      this.props.changeEnttity();
    }
  }

  handleChangeBackground(entity) {
    switch (entity && entity.AyuntamientoID) {
      case 206:
        return "";
      case 180:
        return entity.CabeceraApp;
      case 429:
        this.setState({ hideChangeEntity: true, entityName: "Viladecans Soluciona" });
        return isWebpSupported()
          ? "https://gecorcloud.com/images/turisme1.webp"
          : "https://gecorcloud.com/images/turisme1.jpg";
      case 294:
        this.setState({ hideChangeEntity: true });
        return isWebpSupported()
          ? "https://gecorcloud.com/images/login.webp"
          : "https://gecorcloud.com/images/login.png";
      default:
        return isWebpSupported()
          ? "https://gecorcloud.com/images/login.webp"
          : "https://gecorcloud.com/images/login.png";
    }
  }

  handleChangePolitic(entity) {
    switch (entity && entity.AyuntamientoID) {
      case 180:
        return "data-tcotillas";
      default:
        return "hide-tcotillas";
    }
  }

  handleSelectedEntity(entity) {
    this.setState({ ao: {} });
    if (this.props.history) {
      this.props.history.replace("/login");
    }
  }

  render() {
    const { entity, currentlySending, error, t } = this.props;
    const { email, password, submitted, ao, loginRequired, hideChangeEntity, entityName, errorReset, successReset } = this.state;
    const showSearch = !entity || (ao && (ao.ao === 0 || ao.ao === "0")) || (entity && (entity.AyuntamientoID === 0 || entity.AyuntamientoID === "0"));

    return (
      <DynamicBackground
        customOverlay="rgba(0, 0, 0, 0.5)"
        background={this.handleChangeBackground(entity)}
      >
        <div className="containerl">
          <div id="login-page">
            <div className="container">
              {loginRequired &&
                <Modal show={loginRequired} onHide={this.handleCloseLoginRequiredModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>{t('login.modalLoginRequired.tittle')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {t('login.modalLoginRequired.body')}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseLoginRequiredModal}>
                      {t('login.modalLoginRequired.btnAccept')}
                    </Button>
                  </Modal.Footer>
                </Modal>}
              {showSearch && (
                <EntitySearch
                  className="ayto-borde"
                  redirect={false}
                  onSelected={this.handleSelectedEntity}
                  ao={ao}
                  hide={false}
                />
              )}
              {entity && !showSearch && (
                <div className="omb_login d-flex justify-content-center">
                  <div className="loginBox">
                    <Card>
                      <Row className="center">
                        <Col sm={12}>
                          <div
                            className="changent"
                            onClick={this.handleChangeEntity}
                          >
                            {entity.AyuntamientoID != 0 && <img className="img-title-logo"
                              src={entity.Logo}
                              alt={entity.AyuntamientoID != 0 ? "logo" : ""}
                            />}
                            <span className="span-title-logo">
                              {entity.Nombre}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      <hr className="line7"></hr>
                      <Card.Body>
                        <blockquote className="blockquote mb-0">
                          <Row className="omb_row-sm-offset-3">
                            <Col md={12} lg={6}>
                              <h5 className="title-register">
                                {t("login.title-login")}
                              </h5>
                              <form
                                name="loginForm"
                                onSubmit={this.handleSubmit}
                                className="loginForm"
                              >
                                {/* {error && (
                                  <span className="red-text helper-text">
                                    {" "}
                                    {error}{" "}
                                  </span>
                                )}
                               */}
                                <Row>
                                  <InputGroup className="mb-3">
                                    <FormControl
                                      type="email"
                                      placeholder={t("login.mail")}
                                      aria-label="Dirección email"
                                      aria-describedby="basic-addon2"
                                      error={
                                        submitted && !email
                                          ? "Email is required"
                                          : ""
                                      }
                                      value={email}
                                      name="email"
                                      onChange={this.handleChange}
                                    />
                                  </InputGroup>

                                </Row>
                                <Row>
                                  <InputGroup className="mb-3">
                                    <FormControl
                                      type="password"
                                      placeholder={t("login.pass")}
                                      aria-label="Contraseña"
                                      aria-describedby="basic-addon2"
                                      error={
                                        submitted && !password
                                          ? "Password is required"
                                          : ""
                                      }
                                      value={password}
                                      name="password"
                                      onChange={this.handleChange}
                                    />
                                  </InputGroup>
                                </Row>
                                {error && (
                                  <span className="red-text helper-text">
                                    {" "}
                                    {t(error)}{" "}
                                  </span>
                                )}
                                <Row>
                                  <Button
                                    variant="info"
                                    type="submit"
                                    size="lg"
                                  >
                                    {t("login.btn")}
                                  </Button>
                                </Row>
                              </form>
                              <div className="recuperate">
                                <p className="omb_forgotPwd">
                                  <a
                                    rel="noopener noreferrer"
                                    href="#"
                                    onClick={this.handleShow}
                                  >
                                    {t("login.f-pass")}
                                  </a>
                                </p>
                                {((ao && !ao.ao) || !ao) && entity && !hideChangeEntity && (
                                  <p className="omb_forgotPwd">
                                    <a
                                      rel="noopener noreferrer"
                                      href="#"
                                      onClick={this.handleChangeEntity}
                                    >
                                      {" "}
                                      {t("login.ch-ayto")}
                                    </a>
                                  </p>
                                )}
                                {/*((ao && !ao.ao) || !ao) && entity &&
                                      <Row className="center">
                                           <Col sm={12}>
                                            <span> {entity.Nombre} - <a href='#' onClick={this.handleChangeEntity}>{t('login.ch-ayto')}</a></span>
                                      </Col>
                                  </Row>
                              */}
                              </div>
                            </Col>
                            <Col lg={1}>
                              <hr className="hr-1"></hr>
                            </Col>
                            <Col md={12} lg={5}>
                              <div className="otherLog">
                                <h5 className="title-login">
                                  {t("login.reg-p1")}
                                </h5>
                                <p className="center-align w-100">
                                  {t("login.reg-p2", { entityName: entity.AliasAPP ? entity.AliasAPP : "Gecor" })}
                                </p>
                                <Row className="social-media-register">
                                  <Col sm={12}>
                                    <SocialLogin {...this.props} onRequireEntity={this.handleChangeEntity} />
                                  </Col>
                                </Row>
                                <Row className={this.handleChangePolitic(entity)} >
                                  <Col sm={12}>
                                    <p>{t("login.ppriv-p1")}<a className="user-politic-tcotilla" onClick={() => forwardTo('/UserDataTcotillasPage')} target="_blank"> {t("login.ppriv-p2")}</a></p>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </blockquote>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}

              {currentlySending && (
                <div className="loader-container">
                  <div className="preloader-wrapper big active loader">
                    <div className="spinner-layer spinner-blue-only">
                      <div className="circle-clipper left">
                        <div className="circle"></div>
                      </div>
                      <div className="gap-patch">
                        <div className="circle"></div>
                      </div>
                      <div className="circle-clipper right">
                        <div className="circle"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal
            show={this.state.open}
            aria-labelledby="example-modal-sizes-title-sm"
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("login.cont-olv")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <label>
                {t("login.input-mail")}
              </label>
              <Row>
                <Col s={12} m={{ span: 6, offset: 3 }}>
                  <Form.Control
                    className="center-align"
                    type="email"
                    name="emailModal"
                    onChange={this.handleChange}
                    placeholder={t("login.mail")}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {errorReset && (<span className="red-text helper-text">
                {" "}
                {t(errorReset)}{" "}
              </span>
              )}
              {successReset && (<span className="sucess-text helper-text">
                {" "}
                {t(successReset)}{" "}
              </span>
              )}
              <Button onClick={this.handleResetPassword}>{t("login.acept")}</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </DynamicBackground>
    );
  }
}

function mapStateToProps(state) {
  const { entities, users } = state;
  const { error, currentlySending, user } = users;
  const { entity } = entities;
  return {
    entity,
    user,
    error,
    currentlySending
  };
}

const mapDispatchToProps = dispatch => ({
  prepareGoogle: () =>
    dispatch(socialLogin.prepare("google", { client_id: googleClientId })),
  prepareFacebook: () =>
    dispatch(socialLogin.prepare("facebook", { appId: facebookAppId })),
  loginFacebook: () => dispatch(socialLogin.request("facebook")),
  loginGoogle: (token) => dispatch(socialLogin.request("google", token)),
  logout: () => dispatch(socialLogout()),
  prepareUser: () => dispatch(userLogout()),
  loadLocalEntity: () => dispatch(entityActions.getLocalEntity()),
  changeEnttity: () => dispatch(entityActions.changeEntity()),
  getEntityById: data => dispatch(entityActions.getEntityById(data)),
  login: data => dispatch(loginRequest(data)),
  resetPassword: data => dispatch(resetPasswordRequest(data)),
  clearError: () => dispatch(clearError())
});
const tLoginPage = withTranslation()(LoginPage);
const connectedLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(tLoginPage);


export { connectedLoginPage as LoginPage };
